import { render, staticRenderFns } from "./MenuIconText.vue?vue&type=template&id=10a158de&"
import script from "./MenuIconText.vue?vue&type=script&lang=js&"
export * from "./MenuIconText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports